// test1740
(1740 && 0);
